import heap from './heap';
export default function trackDarkMode() {
    if ('matchMedia' in window && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        heap('track', ['Dark mode detected']);
    }
}
